









    import Vue from 'Vue';
    import Vuetify from 'Vuetify';
    import { INavigationItem } from '../../../../../../CommonScripts/Abstractions';
    export default Vue.extend({
        name: 'navigation-item',
        props: {
            navigationItem: { type: Object as () => INavigationItem, required: true }
        },
        computed: {
            navigationText(): string {
                return this.$vuetify.lang.t(this.navigationItem.localisationKey);
            },
            cssClasses(): string {
                return `${this.navigationItem.cssClasses}`;
            }
        },
        methods: {
            clicked() {
                this.$emit('click');
                if (this.navigationItem.to) {
                    this.$router.push(this.navigationItem.to)
                }
                else if (this.navigationItem.href) {
                    window.open(this.navigationItem.href, this.navigationItem.target);
                }
                if (this.navigationItem.clickHandler){
                    this.navigationItem.clickHandler();
                }
            }
        }
    }); 
